import React, { Fragment } from "react";
import DataTable, { defaultThemes } from "react-data-table-component";
import "react-data-table-component-extensions/dist/index.css";
import Button from "../Button";
import {
  ArrowDownIcon,
  ArrowUpIcon,
  DocumentMinusIcon,
} from "@heroicons/react/24/solid";
import { Popover } from "@headlessui/react";
import CustomLoader from "../CustomLoader";
import { keyframes } from "styled-components";
import DeactivateButton from "../DeactivateButton";

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const localCustomStyles = {
  headCells: {
    style: {
      color: "#203A75",
      fontSize: "12px",
      fontWeight: "bold",
    },
  },

  rows: {
    style: {
      padding: "5px 0px",
      width: "100%",
      // whiteSpace: "nowrap",
    },
  },
  expanderButton: {
    style: {
      display: "none",
    },
  },
  expanderCell: {
    style: {
      display: "none",
    },
  },
  // cells: {
  //   style: {
  //     paddingLeft: "1px", // override the cell padding for data cells
  //     paddingRight: "1px",
  //     alignText: "center",
  //   },
  // },
};

const conditionalRowStyles = [
  {
    when: (row) => row.expandRow === true,
    style: {
      borderLeft: "2px solid rgba(12, 119, 189, var(--tw-border-opacity))",
      backgroundColor: "#F7F7F7",
      //paddingLeft: "10px",
    },
  },
  // {
  //   when: (row) => row.editRow === true,
  //   style: {
  //     border: "2px solid #0C77BD",
  //     padding: "2px",
  //     backgroundColor: "#F0F8FF",
  //   },
  // },
];
const Table = ({
  columns,
  data = [],
  className = "",
  noTableHead = false,
  customStyles = localCustomStyles,
  expandableRows = false,
  expandableRowsComponent,
  expandableRowExpanded,
  loading = false,
  pagination = true,
  highlightOnHover = true,
  selectableRows = true,
  onSelectedRowsChange,
  clearSelectedRows,
  selectedRows = [],
  selectableRowDisabled = false,
  setOpenModal,
  // setIsBulkSelected,
  isDeactive = false,
  onRowExpandToggled = undefined,
}) => {
  return (
    <Fragment>
      <div className=" rounded-b-2xl  rounded-r-xl ">
        {selectedRows.length > 0 ? (
          <Popover className="rounded-lg  ">
            <div className="flex my-2 justify-start">
              <DeactivateButton
                onClickFunction={() => {
                  setOpenModal(true);
                  //setIsBulkSelected(true);
                }}
              >
                <DocumentMinusIcon className="h-4 w-4" />{" "}
                {isDeactive ? "Deactivate" : "Delete"}
              </DeactivateButton>
              <div className="mt-1 ml-2 text-xs text-primary text-medium ">
                {isDeactive ? "Deactivate" : "Delete"} Selected Row/s
                <p className="inline-block font-bold">
                  &nbsp;({selectedRows.length})
                </p>
              </div>
            </div>
          </Popover>
        ) : null}
        <div className="box-shadow">
          <DataTable
            subHeaderWrap={true}
            style={{
              overflow: "none",
              textOverflow: "unset",
              whiteSpace: "unset ",
            }}
            //pointerOnHover={true}
            className={className}
            selectableRows={selectableRows}
            onSelectedRowsChange={onSelectedRowsChange}
            columns={columns}
            noDataComponent={
              !data ? (
                <CustomLoader />
              ) : data?.length > 0 ? (
                <CustomLoader />
              ) : (
                "No records found"
              )
            }
            data={data}
            progressPending={loading}
            progressComponent={<CustomLoader />}
            pagination={pagination}
            noTableHead={noTableHead}
            persistTableHead={true}
            highlightOnHover={highlightOnHover}
            expandIcon={({ expanded, onExpand, record }) =>
              expanded ? (
                <ArrowUpIcon
                  style={{ display: "none !important" }}
                  onClick={(e) => onExpand(record, e)}
                />
              ) : (
                <ArrowDownIcon onClick={(e) => onExpand(record, e)} />
              )
            }
            expandableRows={expandableRows}
            expandableRowsComponent={expandableRowsComponent}
            expandableRowExpanded={expandableRowExpanded}
            onRowExpandToggled={onRowExpandToggled}
            customStyles={customStyles}
            conditionalRowStyles={conditionalRowStyles}
            dense={true}
            clearSelectedRows={clearSelectedRows}
            selectableRowDisabled={selectableRowDisabled}
            isDeactive={isDeactive}
          />
        </div>
      </div>
    </Fragment>
  );
};

export default Table;
